module.exports = {
	"name": "stash_web_client",
	"homepage": "https://app.stashandfetch.com",
	"loginPage": "https://stashandfetch.com/login",
	"apiRoot": "https://api.stashandfetch.com/api/v1",
	"pageLimit": 20,
	"searchPageLimit": 30,
	"version": "0.2.0",
	"private": true,
	"devDependencies": {
		"react-scripts": "0.9.5"
	},
	"dependencies": {
		"axios": "^0.15.3",
		"bootstrap": "^3.3.7",
		"font-awesome": "^4.7.0",
		"ionicons-npm": "^2.0.1",
		"material-ui": "^0.17.4",
		"moment-timezone": "^0.5.11",
		"mousetrap": "^1.6.1",
		"parse-link-header": "^0.4.1",
		"react": "^15.4.2",
		"react-avatar-editor": "^10.0.3",
		"react-dom": "^15.4.2",
		"react-masonry-component": "^5.0.3",
		"react-moment": "^0.2.2",
		"react-router-dom": "^4.1.1",
		"react-tap-event-plugin": "^2.0.1",
		"react-window-resize-listener": "^1.1.0",
		"roboto-fontface": "^0.7.0"
	},
	"scripts": {
		"start": "react-scripts start",
		"build": "react-scripts build",
		"test": "react-scripts test --env=jsdom",
		"eject": "react-scripts eject"
	}
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 108
// module chunks = 0